import { Injectable } from '@angular/core';
import { EntryMetaData } from '../../shared/fs-entry.model';
import { parseDate, formatFileSize, decodeHtmlEntities, prepareFallbackId } from '../../shared/utils';

@Injectable({
  providedIn: 'root'
})
export class FieldParsingService {

  constructor() { }

  parseEntries(entries): EntryMetaData[] {
    let parsedEntries: EntryMetaData[] = [];

    if (entries) {
      entries.forEach(entry => {
        parsedEntries.push(this.mapEntryModel(entry));
      });
    }
  
    return parsedEntries;
  }

  mapEntryModel(entry): EntryMetaData {
    return {
      createdBy: entry.Creator || "",
      creationDate: parseDate(entry.CreationTime || ""),
      entryId: entry.EntryId,
      extension: entry.Extension || "",
      lastModified: parseDate(entry.LastModifiedTime || ""),
      lastModifiedBy: entry.ModifiedBy || "",
      name: entry.Name,
      checkedOutBy: entry.CheckedOutBy || "",
      electronicFileLastModified: entry.ElectronicFileLastModified || "",
      hasTags: entry.HasTags,
      indexed: entry.Indexed,
      latestVersion: entry.LatestVersion || "",
      locationDescription: entry.LocationDescription || "",
      pages: entry.Pages || "",
      template: entry.Template || "",
      totalDocumentSize: formatFileSize(parseInt(entry.TotalDocumentSize || "")),
      fields: entry.Fields?.map((field) => { field.Name = decodeHtmlEntities(field.Name); return field;}) || [],
      notFound: entry.NotFound,
      allProps: entry
    } as EntryMetaData
  }
}
